import React from 'react';
import {
  Form,
  Input,
  RequiredHelpPhrase,
  Row,
  SonForm,
  SubmitButton,
  Textarea,
  TextAreaParam,
  TextParam,
  useForm,
} from '../../index';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { AxiosResponse } from 'axios';
import { BlockType } from '../../../../types/api/ElementType';

export type CreateEditUserToPageRoleFormProps = {
  form: SonForm<TextParam<'name'> | TextAreaParam<'description'>>;
  onSuccess?: (response: AxiosResponse) => void;
  elementType: BlockType.usertouserrolepagelead | BlockType.usertopagerolepagelead;
  isEditing?: boolean;
};

export function CreateEditUserToPageRoleForm({
  form,
  onSuccess,
  elementType,
  isEditing = true,
}: CreateEditUserToPageRoleFormProps) {
  const { t } = useSonTranslation('RolePageLead');

  const { formProps, params, fetchState } = useForm({ form, onSuccess: onSuccess });

  const nameParam = params.getByName('name');
  const descriptionParam = params.findByName('description');

  return (
    <Form {...formProps}>
      <RequiredHelpPhrase />
      <Row>
        <Input label={t(`${elementType}.roleNameLabel`)} param={nameParam} />
      </Row>
      {descriptionParam ? (
        <Row>
          <Textarea label={t(`${elementType}.descriptionLabel`)} param={descriptionParam} />
        </Row>
      ) : null}
      <SubmitButton
        buttonLabel={isEditing ? t('phrases:saveChanges') : t('createRole')}
        messageSuccess={t('phrases:changeSuccesfull')}
        messageSending={t('phrases:changeSending')}
        messageFail={t('phrases:changesCouldNotBeSaved')}
        messageForward={t('phrases:successForward')}
        fetchState={fetchState}
      />
    </Form>
  );
}
